module.exports = __webpack_public_path__ + "img/login-vector.06b671e6.svg";